export default {
  allInfractions: [],
}
